module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vipAppointmentDetila"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: true
      }
    }
  }, [_vm._v("锦欣生殖VIP简介")]), _vm._v(" "), _c('img', {
    staticClass: "zxIMG",
    attrs: {
      "src": _vm.imgzx
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dection",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0em"
    }
  }, [_vm._v("VIP医疗中心成立于2016年")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("服务升级")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("设备升级")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("精准化制定个人助孕方案")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("提高个人成功率")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("优化个人时间成本")]), _vm._v(" "), _c('h3', [_vm._v("医疗团队介绍")]), _vm._v(" "), _c('div', {
    staticClass: "doctor"
  }, [_c('flexbox', [_c('flexbox-item', {
    attrs: {
      "span": 4
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgwd
    }
  })]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "doctorCon"
  }, [_c('h4', [_vm._v("吴东 副高级职称")]), _vm._v(" "), _c('p', [_vm._v("从事不孕不育专业30余年,中华医学会妇产科学会委员,先后获得国家科技成果奖一项，省、市科技成果奖两项。")])])])], 1), _vm._v(" "), _c('flexbox', {
    staticStyle: {
      "border-bottom": "1px solid #aadafa",
      "margin-bottom": "10px"
    }
  }, [_c('flexbox-item', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "doctorCon"
  }, [_c('p', [_vm._v("擅长：辅助生殖术前、术后调整治疗；不孕症中西医结合治疗；早期妊娠保胎治疗；高龄失败重复周期；")])])])], 1), _vm._v(" "), _c('flexbox', [_c('flexbox-item', {
    attrs: {
      "span": 4
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgwll
    }
  })]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "doctorCon"
  }, [_c('h4', [_vm._v("王莉莉 副高级职称")]), _vm._v(" "), _c('p', [_vm._v("四川大学华西医学院-生殖内分泌硕士")])])])], 1), _vm._v(" "), _c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "doctorCon"
  }, [_c('p', [_vm._v("赴“西班牙/芬兰/美国/日本”等著名生殖中心进修学习。多次在国内核心期刊发表科研论文，参与的科研课题获省级科研课题成果奖、中国非公立医疗机构协会生殖医学专业委员会，第一届委员会委员。")]), _vm._v(" "), _c('p', [_vm._v("擅长：不孕不育诊治；试管婴儿及人工授精技术；宫腹腔镜手术；妇科内分泌疾病诊治；多囊卵巢综合症；")])])])], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("VIP医疗优势")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("08：00--19：00 周期就诊")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("全程精准化，合理有效预约")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("二小时结束就诊（抽血查激素+B超+看诊）")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("全程医生一对一，深度沟通10-20分钟，仔细想慢慢说。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("资深手术医生行取卵、移植手术，高职称、高资历、手法娴熟。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("个体化综合助孕支撑订制，男科、中医、NSP健康管理中心（运动、营养、心理）全方位支撑助孕治疗。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("世界先进精子放大系统，高倍单独挑选更优质精子。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("世界顶级Time-lapse胚胎培养箱，可以更好的培养胚胎，更精确的选择优质胚胎移植。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("独立的候诊室，保护个人隐私，增进医患沟通效率。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("远程看诊，路途很远，网络很近，我们只是隔着一个屏幕的距离。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("外地药品、资料邮寄，你的需要有时候只是一个电话就能解决。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("24小时线上、线下医疗服务，你的需要不只是在医院，也许还有路上、家里，不管何时何地，24小时你都有我们专业的陪伴。")]), _vm._v(" "), _c('h3', [_vm._v("免费福利")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("免挂号费、免注射费、免周期B超费，送早、午营养餐食，送瑜伽、单车运动。")]), _vm._v(" "), _c('h3', [_vm._v("VIP患者管理")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("24小时电话医疗咨询、24小时网络咨询。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("就诊流程精确性安排")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("体检全程陪诊")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("手术全程陪同")]), _vm._v(" "), _c('h3', [_vm._v("VIP套餐")]), _vm._v(" "), _c('p', {
    staticClass: "little"
  }, [_vm._v("三万套餐")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("适用于：ART所有助孕方案。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("时间：一年以内不限制周期数,产生医疗费用除赠送项目其余自理。")]), _vm._v(" "), _c('p', {
    staticClass: "little"
  }, [_vm._v("五千套餐")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("适用于：FET、IUI助孕方案。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("时间：一年以内一次周期数，产生医疗费用除赠送项目其余自理。")]), _vm._v(" "), _c('h3', [_vm._v("VIP咨询")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('h3', [_vm._v("VIP办理须知")]), _vm._v(" "), _c('p', {
    staticClass: "little"
  }, [_vm._v("凭以下证件办理")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("双方有效结婚证")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("双方有效身份证")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "border"
  }, [_vm._v("张静："), _c('a', {
    staticStyle: {
      "color": "#4ba7e8"
    },
    attrs: {
      "href": "tel:18380470968"
    }
  }, [_vm._v("18380470968")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "border"
  }, [_vm._v("李茜："), _c('a', {
    staticStyle: {
      "color": "#4ba7e8"
    },
    attrs: {
      "href": "tel:18382436008"
    }
  }, [_vm._v("18382436008")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "border"
  }, [_vm._v("陈丽亘："), _c('a', {
    staticStyle: {
      "color": "#4ba7e8"
    },
    attrs: {
      "href": "tel:18380338002"
    }
  }, [_vm._v("18380338002")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51db58bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/vipnotifyProject/vipAppointmentDetila.vue
// module id = sUMl
// module chunks = 5